import * as React from "react"
import styled from "@digits-css"
import { LogoLoading } from "@digits-shared/components/Loaders/Page"
import { MetaTags } from "@digits-shared/components/MetaTags/MetaTags"
import colors from "@digits-shared/themes/colors"
import "./Module.digits.css"

export const ModuleLoadingStyled = styled.div({ cls: "Module__ModuleLoadingStyled_6afc356" })

export const ModuleLoading: React.FC<{ className?: string }> = ({ className }) => (
  <ModuleLoadingStyled className={className}>
    <LogoLoading size="60px" />
  </ModuleLoadingStyled>
)

export const SpringboardModuleLoading: React.FC<{ className?: string }> = ({ className }) => (
  <>
    <MetaTags>
      <meta name="theme-color" content="#B8D2E5" />
    </MetaTags>
    <ModuleLoadingStyled className={className}>
      <LogoLoading size="60px" />
    </ModuleLoadingStyled>
  </>
)
